<template>
  <!-- 幼儿园计价规则模板 -->
  <el-card
    shadow="hover"
    style="width:815px"
  >
    <el-form
      ref="ruleTemp"
      label-width="120px"
    >
      <el-form-item
        label="收费对象："
        prop="subject"
      >
        <el-radio-group v-model="loveChild.subject">
          <el-radio label="c">TO C</el-radio>
          <el-radio
            label="b"
            disabled
          >TO B</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="基础单价："
        prop="price"
      >
        <el-col :span="12">
          <el-input
            v-model="loveChild.price"
            oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,3})?/)"
            onpaste="this.value=this.value.toString().match(/^\d+(?:\.\d{0,3})?/)"
            placeholder="请输入基础单价"
          ></el-input>
        </el-col>
        <el-col
          :span="10"
          :offset="1"
        >元/天</el-col>
      </el-form-item>
      <el-form-item
        label="折扣方式："
        prop="discount"
      >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          plain
          @click="addDiscountMethod"
        >新增折扣方式</el-button>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          plain
          @click="returnResult"
        >生成配置结果</el-button>
        <p>时间范围请设置为连续天数如：1-29；30-59</p>
      </el-form-item>
      <div
        v-for="(item,index) in loveChild.discount"
        :key="index"
        class="clearfix ruleTemp-discount-wrap"
      >
        <div
          :prop="'discount.' + index +'.from'"
          style="width:100px;float:left"
        >
          <el-input
            v-model="item.from"
            oninput="if(!/^[1-9]\d*$/.test(value)){value=''}"
            onpaste="if(!/^[1-9]\d*$/.test(value)){value=''}"
            placeholder
          ></el-input>
        </div>
        <span
          class="ruleTemp-discount-span"
          style="width:30px;"
        >至</span>
        <div
          :prop="'discount.' + index +'.to'"
          style="width:100px;float:left"
        >
          <el-input
            v-model="item.to"
            oninput="if(!/^[1-9]\d*$/.test(value)){value=''}"
            onpaste="if(!/^[1-9]\d*$/.test(value)){value=''}"
            placeholder
          ></el-input>
        </div>
        <span
          class="ruleTemp-discount-span"
          style="width:100px;"
        >天， 折扣为</span>
        <div
          :prop="'discount.' + index +'.percent'"
          style="width:100px;float:left"
        >
          <el-input
            v-model="item.percent"
            oninput="if(!/(^0$)|(^100$)|(^\d{1,2}$)/.test(value)){value=''}"
            onpaste="if(!/(^0$)|(^100$)|(^\d{1,2}$)/.test(value)){value=''}"
            placeholder
          ></el-input>
        </div>
        <span
          class="ruleTemp-discount-span"
          style="width:30px;"
        >%</span>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-minus"
          plain
          @click.prevent="removeDiscountMethod(index)"
          title="删除折扣方式"
          style="positon:relative;top:3px;float:left"
        ></el-button>
      </div>
      <el-form-item
        label="配置结果："
        style="margin-bottom:0"
      ></el-form-item>
      <el-form-item prop="desc">
        <el-col class="text-wrap">{{ loveChild.desc }}</el-col>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  props: ['loveChild'],
  name: 'valuationTemplate4',
  data () {
    return {
      ruleTemp: {
        subject: 'c',
        price: '1',
        discount: [
          {
            from: '1',
            to: '29',
            percent: '90'
          }
        ],
        desc: '111111111'
      }
    }
  },
  watch: {
    // ruleTemp: {
    //   handler(newValue, oldValue) {
    //     let discount = newValue.discount;
    //     this.returnResult(discount);
    //   },
    //   deep: true
    // }
  },
  computed: {},
  methods: {
    returnResult () {
      console.log('kk')
      this.$emit('returnResult')
      // let _self = this
      // if (data.discount.length) {
      //   for (let i = 0; i < data.discount.length; i++) {
      //     _self.ruleTemp.desc =
      //       'TO ' +
      //       _self.ruleTemp.subject +
      //       ',基础 ' +
      //       _self.ruleTemp.price +
      //       ' 元/天 ; ' +
      //       data[i].from +
      //       '-' +
      //       data[i].to +
      //       ' 天，折扣' +
      //       data[i].percent +
      //       '% ;'
      //   }
      // }
    },
    /* 新增折扣方式 */
    addDiscountMethod () {
      let op = {
        from: '',
        to: '',
        percent: ''
      }
      this.$emit('addDiscountMethod', op)
      // this.ruleTemp.discount.push({
      //   from: '',
      //   to: '',
      //   percent: ''
      // })
    },
    removeDiscountMethod (index) {
      this.$emit('removeDiscountMethod', index)
      // let index = this.ruleTemp.discount.indexOf(item)
      // this.ruleTemp.discount.splice(index, 1)
    },
    result () {
      console.log(this.ruleTemp.discount)
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "../../assets/sass/base.scss";
.ruleTemp-discount-span {
  display: inline-block;
  float: left !important;
  line-height: 40px;
  text-align: center;
}
.clearfix {
  @include clearfix;
}
.text-wrap {
  overflow: hidden;
  line-height: 30px;
  width: 100%;
}
.ruleTemp-discount-wrap {
  padding-left: 120px;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/valuation/valuationTemplate4.vue